// extracted by mini-css-extract-plugin
export default {"back":"Welly_back__5vyp3","mWR":"Welly_mWR__zcyea","bank":"Welly_bank__NFCAD","block":"Welly_block__KQjkI","but":"Welly_but__fzkp+","main":"Welly_main__ESeuJ"};